import { Component, Input, OnInit } from '@angular/core';
import { Device } from "../../../../model/device";
import { DevicesService } from "../../../../services/devices.service";
import { IntegrationModule } from "../../../../model/integration-module";

@Component({
  selector: 'app-device-integration-modules',
  templateUrl: './device-integration-modules.component.html',
  styleUrls: ['./device-integration-modules.component.scss']
})
export class DeviceIntegrationModulesComponent implements OnInit {

  @Input()
  public device: Device;

  public integrationModules: IntegrationModule[];
  public totalModules: number;
  public loadingModules: boolean;

  public rows = 10;
  public first = 0;

  constructor(private devicesService: DevicesService) {
    this.integrationModules = [];
  }

  ngOnInit(): void {
    this.loadIntegrationModules();
  }

  loadIntegrationModules() {
    this.loadingModules = true;
    this.integrationModules = new Array(this.rows);
    this.devicesService.getDeviceIntegrationModules(this.device.uuid).subscribe(response => {
      this.integrationModules = response.integrationModules;
      let dataKey = 0;
      this.integrationModules.forEach(module => {
        if(module.additionalInfo) {
          try {
            module.additionalInfo = JSON.parse(module.additionalInfo);
          } catch (e) {
            module.additionalInfo = null;
          }
        }
        if(module.technicalDetails) {
          try {
            module.technicalDetails = JSON.parse(module.technicalDetails);
          } catch (e) {
            module.technicalDetails = null;
          }
        }
        module['dataKey'] = dataKey++;
      });
      this.totalModules = this.integrationModules.length;
      this.loadingModules = false;
    })
  }
}
